export default "__VITE_ASSET__CmKtcojA__"